export default __webpack_public_path__ + "static/media/kenya_flag.ae824fe2.png";